module.exports = __webpack_public_path__ + "media/images/icons/flags/CY-f928b684d535b7d1b74d939f157fc4cf.svg";